<template>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h1 class="text-left">{{$tc('process.template', 2)}}</h1>

                <b-nav tabs>
                    <b-nav-item v-can="'Read_FormulaPrefix'" to="/setup-prefix/formula" exact exact-active-class="active">{{$t('prefix.prefixFormula')}}</b-nav-item>
                    <b-nav-item v-can="'Read_MaterialPrefix'" to="/setup-prefix/material" exact exact-active-class="active">{{$tc('general.material', 1)}}</b-nav-item>
                </b-nav>

                <router-view></router-view>

            </div>
        </div>
    </div>

</div>
</template>

<script>

import Feedback from '../mixins/Feedback.js'

window.axios = require("axios");

export default {
    name: 'Setup-Prefix',

    mixins: [Feedback],

    components: {

    },
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style>
.btn-icon {
    cursor: pointer;
    margin: 0px 5px;
}
</style>
